<template>
  <div>
    <!-- マニフェスト番号(紙マニ返却日ダイヤログ用) -->
    <v-row
      v-if="callerType === 'paper_register'"
      dense
    >
      <v-col
        cols="12"
        md="6"
      >
        <div class="fieldsetLabel">
          <fieldset>
            <legend>マニフェスト番号</legend>
            <span>{{ manifest.manifest_no }}&nbsp;</span>
          </fieldset>
        </div>
      </v-col>
    </v-row>
    <!-- /マニフェスト番号(紙マニ返却日ダイヤログ用) -->
    <!-- 排出事業者 事業者名称／排出事業場 事業場名称／運搬ルート名 -->
    <v-row dense>
      <v-col cols="12" md="4">
        <div class="fieldsetLabel">
          <fieldset>
            <legend>排出事業者 事業者名称</legend>
            <span>{{ manifest.emission_name }}&nbsp;</span>
          </fieldset>
        </div>
      </v-col>
      <v-col cols="12" md="4">
        <div class="fieldsetLabel">
          <fieldset>
            <legend>排出事業場 事業場名称</legend>
            <span>{{ manifest.emission_location_name }}&nbsp;</span>
          </fieldset>
        </div>
      </v-col>
      <v-col cols="12" md="4">
        <div class="fieldsetLabel">
          <fieldset>
            <legend>運搬ルート名</legend>
            <span>{{ manifest.transport_route_name }}&nbsp;</span>
          </fieldset>
        </div>
      </v-col>
    </v-row>
    <!-- /排出事業者 事業者名称／排出事業場 事業場名称／運搬ルート名 -->
    <!-- 運搬先 事業者名称／回収日／マニフェスト番号(各種報告ダイヤログ用) -->
    <v-row
      v-if="callerType === 'completion_report'"
      dense
    >
      <v-col cols="12" md="4">
        <div class="fieldsetLabel">
          <fieldset>
            <legend>運搬先 事業者名称</legend>
            <span>{{ manifest.trader_name }}&nbsp;</span>
          </fieldset>
        </div>
      </v-col>
      <v-col
        v-if="(callerType === 'completion_report') || (callerType ==='disposal_report')"
        cols="12"
        md="4"
      >
        <div class="fieldsetLabel">
          <fieldset>
            <legend>回収日</legend>
            <span>{{ manifest.collected_date | date_format }}&nbsp;</span>
          </fieldset>
        </div>
      </v-col>
      <v-col
        v-if="callerType !== 'paper_register'"
        cols="12"
        md="4"
      >
        <div class="fieldsetLabel">
          <fieldset>
            <legend>マニフェスト番号</legend>
            <span>{{ manifest.manifest_no }}&nbsp;</span>
          </fieldset>
        </div>
      </v-col>
    </v-row>
    <!-- /運搬先 事業者名称／回収日／マニフェスト番号(各種報告ダイヤログ用) -->

    <!-- 廃棄物の種類／廃棄物の名称 -->
    <v-row dense>
      <v-col cols="12" md="6">
        <div class="fieldsetLabel">
          <fieldset>
            <legend>廃棄物の種類</legend>
            <span>{{ manifest.item_name }}&nbsp;</span>
          </fieldset>
        </div>
      </v-col>
      <v-col cols="12" md="6">
        <div class="fieldsetLabel">
          <fieldset>
            <legend>廃棄物の名称</legend>
            <span>{{ manifest.waste_name }}&nbsp;</span>
          </fieldset>
        </div>
      </v-col>
    </v-row>
    <!-- /廃棄物の種類／廃棄物の名称 -->
    <!-- 数量／数量単位／数量の確定者 -->
    <v-row dense>
      <v-col v-if="manifest.order_type !== 'self_emission'" cols="12" md="3">
        <div class="fieldsetLabel">
          <fieldset>
            <legend>数量</legend>
            <span class="number">{{ manifest.quantity }}&nbsp;</span>
          </fieldset>
        </div>
      </v-col>
      <v-col v-if="manifest.order_type !== 'self_emission'" cols="12" md="3">
        <div class="fieldsetLabel">
          <fieldset>
            <legend>数量単位</legend>
            <span>{{ manifest.quantity_unit_name }}&nbsp;</span>
          </fieldset>
        </div>
      </v-col>
      <v-col cols="12" md="6">
        <div class="fieldsetLabel">
          <fieldset>
            <legend>数量の確定者</legend>
            <span>{{ manifest.quantity_confirm_name }}&nbsp;</span>
          </fieldset>
        </div>
      </v-col>
    </v-row>
    <!-- /数量／数量単位／数量の確定者 -->
  </div>
</template>

<script>
export default {
  name: 'ManifestDetail',
  components: {},
  mixins: [],
  props: {
    /**
     * @params manifest {Object} マニフェスト
     * @property order_type { string } オーダー種別
     * @property quantity_unit_name { string }
     * @property quantity_confirm_name { string }
     *
     */
    manifest: {
      type: Object,
      default: () => {},
    },
    callerType: {
      type: String,
      default: () => null,
    },
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {
  },
  methods: {}
}
</script>

<style scoped lang="scss">

</style>
